import React from 'react';
import {loginWithDiscord} from '../../services/api';
import './LoginPrompt.css';

/**
 * Full-page (or in-content) prompt shown when the user must be logged in.
 *
 * Props:
 *   message {string} – optional override for the body text
 */
export default function LoginPrompt({
  message = 'You need to be logged in to view this page.'
}) {
  return (
      <div className="login-prompt">
        <div className="login-prompt-icon">🔒</div>
        <p className="login-prompt-message">{message}</p>
        <button
            type="button"
            className="login-prompt-button"
            onClick={loginWithDiscord}
        >
          Log in with Discord
        </button>
      </div>
  );
}

